export default {
  methods: {
    can(permissionName) {
      const permissions = window.localStorage.getItem('all_permission')
      if (typeof permissions != 'undefined') {
        return permissions?.indexOf(permissionName) > -1
      }
    },
    getUserRole() {
      var userData = getUserData();
      var regional = userData.regional ?? null;
  
      const roleAdmin = can("admin/home");
      const rolePA = can("pa/home");
      const roleLokas = can("lokas/home");
      const roleRemunerasi = can("remunerasi/home");
  
      // Logika kondisional tetap sama, karena ini adalah yang paling jelas dan efisien untuk kasus ini.
      if (roleAdmin && rolePA && roleLokas && roleRemunerasi) {
        return "superadmin";
      } else if (roleAdmin && regional === "99") { // Menggunakan === untuk perbandingan ketat
        return "Admin Nasional";
      } else if (roleAdmin && regional !== "99") { // Menggunakan !== untuk perbandingan ketat
        return "Admin Sppd";
      } else if (rolePA && regional === "99") {
        return "Approval Ruta/PA";
      } else if (rolePA && regional !== "99") {
        return "Approval PA Regional";
      } else if (roleLokas) { // Jika roleLokas bernilai truthy (bukan null, undefined, false, 0, '')
        return "Lokas";
      } else if (roleRemunerasi && regional === "99") {
        return "Remunerasi Nasional";
      } else if (roleRemunerasi && regional !== "99") {
        return "Remunerasi Regional";
      } else {
        return "Pegawai";
      }
    }
  },
}
